import { render, staticRenderFns } from "./DetailImageEditViewer.vue?vue&type=template&id=37dd40d6&"
import script from "./DetailImageEditViewer.vue?vue&type=script&lang=js&"
export * from "./DetailImageEditViewer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports